// src/services/FileService.js
import bilAPI from "../api";
export const getFileByModule = ({ module_code, day, month, group }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/core/files/get_file/", {
          params: {
            module_code,
            day,
            month,
            group,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};

export const searchFilesByModule = ({ module_code, day, month, group }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/core/files/search_files/", {
          params: {
            module_code,
            day,
            month,
            group,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};
